export default {
  all: 'すべて',
  back: '戻る',
  searchResults: '検索結果',
  searchPlaceholder: '検索',
  apply: 'フィルタ条件を適用する',
  clearAll: '全てクリア',
  addResourceToPlayable: {
    editInfo: [
      '現在の更新操作で、ノードが選択されていません',
      'ゲームがロードされていません',
    ],
    editError: [
      '追加に失敗しました',
      '各シーンには最大4つの動画がサポートされています',
      'このアセットは削除されたため、再選択してください',
    ],
  },
  audioList: {
    deleteError: '削除に失敗しました',
  },
  audioUploader: {
    localUpload: 'ローカルにアップロード',
    uploadRule: [
      '音声効果のアップロードはできません',
      '形式である必要があります',
      '音声の最大サイズ',
    ],
    tips: 'すべてのアセットを閲覧する',
    uploadRuleTips: {
      format: '音声ファイルの形式',
      fileSize: '音声ファイルのサイズ',
    },
  },
  deleteResource: {
    deleteError: '削除失敗',
  },
  dialog: {
    image: 'マイ画像',
    aImage: 'マイアニメーション画像',
    xlz: 'マイシーケンスフレーム',
    text: 'テキスト',
    video: '動画',
    audio: 'マイ音声',
    bgm: 'マイBGM',
    particleEffect: 'パーティクル',
    assetLibrary: 'マイアセット',
    tips: '現在の形式要件に合致するアセットのみ表示',
  },
  imageUploader: {
    uploadRule: [
      'アップロードされる画像は',
      '形式である必要があります！',
      '画像の最大サイズ',
      '画像リソースはxxxを超えることはできません。修正して再試行してください',
    ],
    uploadRuleTips: {
      format: '画像ファイルの形式',
      fileSize: '画像ファイルのサイズ',
    },
  },
  resource: {
    noFoundError: '名前は数字で終わる必要があります。',
  },
  textList: {
    gameNotLoad: 'ゲームがロードされていません。',
  },
  videoUploader: {
    uploadRule: [
      'アップロードされる動画は',
      'フォーマットである必要があります！',
      '最大動画サイズ',
    ],
    sceneSupport: '各シーンには最大4つの動画がサポートされています。',
    uploadRuleTips: {
      format: '動画ファイル形式',
      fileSize: '動画ファイルサイズ',
    },
  },
  xlzUploader: {
    exceed: '単一の画像の最大サイズ',
    addXlzError:
      'シーケンスフレームの追加に失敗しました。後でもう一度試してください。',
  },
  emptyNodeCategory: {
    label: 'インタラクティブエリア',
    text: 'インタラクティブエリア',
  },
  dragonBone: {
    required:
      'DragonBonesには **_ske.json、**_tex.json、**_tex.png の3つのファイルのみが許可され、** は一致する必要があります。',
  },
  categoryList: {
    commonLib: {
      label: '共有リソース',
      text: '共有リソース',
    },
    assetLib: {
      label: 'マイアセット',
      text: 'マイアセット',
    },
    resourcePool: {
      label: 'リソースライブラリ',
      text: 'リソースライブラリ',
    },
    image: {
      label: '画像',
      text: '画像',
      commonImage: '画像ライブラリ',
    },
    aImage: {
      label: 'アニメーション画像',
      text: 'アニメーション画像',
      commonImage: 'アニメーション画像ライブラリ',
    },
    video: {
      label: '動画',
      text: '動画',
    },
    audio: {
      label: '効果音',
      text: '効果音',
      commonAudio: '効果音ライブラリ',
    },
    text: {
      label: 'テキスト',
      text: 'テキスト',
    },
    bgm: {
      label: 'BGM（背景音楽）',
      text: 'BGM（背景音楽）',
      commonBgm: 'BGMライブラリ',
    },
    effect: {
      label: 'パーティクル',
      text: 'パーティクル',
      myEffect: 'マイアニメーション',
      xlzUploaderTitle: 'シーケンスフレームをアップロード',
      xlzUploaderTips: '複数の画像を選択してアップロード',
      dragonUploaderTitle: '.Jsonファイルをアップロード',
      dragonUploaderTips: 'ZIP（json+png）形式に対応しています',
      xlzTxt: 'シーケンスフレーム',
      particlesTxt: 'パーティクル',
      dragonTxt: 'DragonBones',
    },
    scene: {
      label: 'プリセットライブラリ',
      text: 'プリセットライブラリ',
    },
    quickLayout: {
      label: 'クイックレイアウト',
      text: 'クイックレイアウト',
    },
    playUnit: {
      label: 'ゲームプレイテンプレート',
      text: 'ゲームプレイテンプレート',
    },
    widgetLib: {
      label: 'コンポーネントライブラリ',
      text: 'コンポーネントライブラリ',
    },
    globalVar: {
      label: 'グローバル変数',
      text: 'グローバル変数',
      addBtn: '変数を追加する',
      addTitle: '新しい変数を追加',
      editTitle: '変数を編集',
      key: '名前',
      varType: '変数のタイプ',
      initValue: '初期値',
      desc: '説明',
      keyPlaceholder: '変数名を入力してください',
      varTypePlaceholder: 'データのタイプを選択してください',
      initValuePlaceholder: '先に変数のタイプを選択してください',
      initNumberPlaceholder: '初期数値を入力してください',
      initStringPlaceholder: '初期テキスト内容を入力してください',
      initBooleanPlaceholder: '初期値を選択してください',
      descPlaceholder: '説明を入力してください（オプション）',
      typeNumber: '数値',
      typeString: 'テキスト',
      typeBoolean: 'ブール値',
      typeGlobalVar: 'グローバル変数',
      cancelBtn: 'キャンセル',
      saveBtn: '保存',
      confirmBtn: '保存します',
      trueValue: 'true',
      falseValue: 'false',
      errorTip: '必須項目',
      errorTip2: '名前は数字で始めることはできません',
      errorTip3: '重複した変数名のグローバル変数が存在します',
      errorTip4: 'playsmartGlobalVarsはシステムキーワードです',
      errorTip4_2: 'timersはシステムキーワードです',
      errorTip5:
        '英数字、アンダースコアのみがサポートされており、20文字を超えることはできません',
      errorTip6: '説明は50文字以下にしてください',
      deleteGlobalVarConfirm:
        'このグローバル変数はイベントに参照されています。削除すると対応するイベントも一緒に削除されます。削除してもよろしいですか？',
      globalVarWarning: '警告',
      editGlobalVarTypeConfirm:
        'このグローバル変数はイベントに参照されています。変数のタイプを変更すると対応するイベントが削除されます。変更してもよろしいですか？',
      editGlobalVarKeyConfirm:
        'このグローバル変数はイベントに参照されています。変数名を変更すると対応するイベントが削除されます。変更してもよろしいですか？',
      noDataTip: 'データがありません',
      noDataTip2: 'ボタンをクリックしてグローバル変数を追加してください',
      conditionCompare: '条件判断',
      addConditionCompare: '+ 条件を追加',
      globalVarKeyPlaceholder: 'グローバル変数',
      compareTypePlaceholder: 'タイプ',
      compareValuePlaceholder: 'タイプを選択してください',
      compareValueNumberPlaceholder: '数値',
      compareValueStringPlaceholder: 'テキスト',
      compareValueBooleanPlaceholder: 'ブーリアン',
      compareValueGlobalVarPlaceholder: 'グローバル変数',
      compareTipIf: 'もし',
      compareTipAnd: 'かつ',
      onlyOnce: '一度だけ有効',
      selectComputeMethod: '演算方法を選択してください',
      deleteCompareWarning:
        'この条件判断を削除すると、対応するイベント応答も同期的に削除されます。削除してもよろしいですか？',
    },
  },
  confirm: '確定',
  dragUpload: {
    note: 'ファイルをドラッグアンドドロップして即座にアップロードできます',
    fileRequired:
      'サポートされているファイル形式：png/jpg/mp3/mp4/ドラゴンボーンzip（json+png）',
    namedRequired:
      'シーケンスフレームのアップロードのネーミング要件：爆破1.png 爆破2.png 爆破3.png（フレームごとに提供）',
  },
  assetLib: {
    PublicAssetLib: 'パブリックアセットライブラリ',
    MyAssetLib: 'マイアセット',
    image: '画像',
    gif: 'アニメーション',
    bgm: '背景音楽',
    soundEffect: '効果音',
    particle: 'パーティクル',
    video: '動画',
    audio: 'オーディオ',
  },
}
